// extracted by mini-css-extract-plugin
export default {"maincontainer":"AllocatedVINAwaited_maincontainer__0-HC0"};